// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__ocYmu","vLegacy":"SelectSecondary_vLegacy__1OX9B","error":"SelectSecondary_error__2J87X","disabled":"SelectSecondary_disabled__EQIqE"};